import { render, staticRenderFns } from "./DeleteStakeholderModal.vue?vue&type=template&id=15c82b49&scoped=true"
import script from "./DeleteStakeholderModal.vue?vue&type=script&lang=js"
export * from "./DeleteStakeholderModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteStakeholderModal.vue?vue&type=style&index=0&id=15c82b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c82b49",
  null
  
)

export default component.exports